import { TypedUseSelectorHook, useSelector } from 'react-redux'
import { IStoreState } from '../reducers/types'

export const useTypedSelector: TypedUseSelectorHook<IStoreState> = useSelector
